import DamWebSocketClient from '../dam/DamWebSocketClient';
import UamWebSocketKeepAliveManager from './uamWebSocketKeepAliveManager';

const EXP_KEY = 'X-Amz-Expires';

const config = {
    logPrefix: 'uamWebSocketClient',
    KeepAliveManagerClass: UamWebSocketKeepAliveManager,
};

export default class UamWebSocketClient extends DamWebSocketClient {
    constructor(assetId, isCreateNew, options, serialNumber) {
        super(assetId, isCreateNew, options, serialNumber, config);
    }

    getExpiry(options) {
        const url = new URL(options.url);
        const expiresRaw = url.searchParams.get(EXP_KEY);

        if (!expiresRaw) {
            throw new Error('Signed URL has no X-Amz-Expires param');
        }

        return Number(expiresRaw) * 1000;
    }
}
